export default { title: 'Prześlij recenzję Google' };
